import { createSlice } from "@reduxjs/toolkit";
import { getUnReviewedSessions } from "./session-reviews-thunk";

const initialState = {
  unReviewedSessions: [],
  loading: false,
  error: null,
  success: null,
};

export const sessionReviews = createSlice({
  name: "sessionReviews",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUnReviewedSessions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUnReviewedSessions.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.unReviewedSessions = action.payload;
    });
    builder.addCase(getUnReviewedSessions.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.success = false;
    });
  },
});

export default sessionReviews.reducer;
